(function() {
	'use strict';
	var $ = avm.require('cash'),
		waypoints = avm.require('avast.web.waypoints'),
		$window = $(window),
		$graph = $('.js-graph'),
		$infoBox = $('.js-info-box'),
		$btnCollapse = $('.btn.cmp-collapse'),
		$close = $('.js-close');


	// Expandable sections
	$btnCollapse.on('click', function (e) {
		var $target = $(this).parent($infoBox);

		if ($target.hasClass('expand')) {
			window.scrollTo(0, $target.offset().top-300);
		}

		$(this).parent($infoBox).toggleClass('expand');
		$(this).toggleClass('collapsed');
		e.preventDefault();
	});
	$close.on('click', function() {
		var $target = $(this).closest('.js-info-box');
		$target.removeClass('expand');
		$(this).siblings($btnCollapse).addClass('collapsed')
	});



	// Animated graph section
	$window.on('resize scroll', function() {
		if (waypoints($graph, null, $window.height() - 100)) {
			$graph.addClass('animate');
		}
	});



})();
